module.exports = __webpack_public_path__ + "img/63_5.e350bd72.png";